'use strict'
import HttpClient from './httpClient'

import CryptoJS from 'crypto-js'

import { timestampsSecondNow } from '@/utils/date'
import Vue from 'vue'

const BASE_URL = `${process.env.VUE_APP_URL_BACKEND}/api/`
const BASE_URL_BACK = `${process.env.VUE_APP_URL_BACKEND}/`

export default {
  noApi: {
    get: (url, params) => {
      return new HttpClient()
        .get(`${BASE_URL_BACK}${url}`, {
          params
        })
        .then(({ data }) => {
          return Promise.resolve(data)
        })
        .catch(error => {
          return Promise.reject(error)
        })
    }
  },
  noauth: {
    get: (url, params) => {
      return new HttpClient()
        .get(`${BASE_URL}${url}`, {
          params
        })
        .then(({ data }) => {
          return Promise.resolve(data)
        })
        .catch(error => {
          return Promise.reject(error)
        })
    },
    post: (url, params) => {
      return new HttpClient()
        .post(`${BASE_URL}${url}`, params)
        .then(({ data }) => {
          return Promise.resolve(data)
        })
        .catch(error => {
          return Promise.reject(error)
        })
    },
    put: (url, params) => {
      return new HttpClient()
        .put(`${BASE_URL}${url}`, params)
        .then(({ data }) => {
          return Promise.resolve(data)
        })
        .catch(error => {
          return Promise.reject(error)
        })
    },
    delete: (url, params) => {
      return new HttpClient()
        .delete(`${BASE_URL}${url}`, params)
        .then(({ data }) => {
          return Promise.resolve(data)
        })
        .catch(error => {
          return Promise.reject(error)
        })
    }
  },
  auth: {
    get: (url, params, headers = {}) => {
      return valideMiddleToken()
        .then(token => {
          return new HttpClient()
            .get(`${BASE_URL}${url}`, {
              params: params,
              headers: Object.assign(
                { Authorization: 'Bearer ' + `${token}` },
                headers
              )
            })
            .then(({ data }) => {
              return Promise.resolve(data)
            })
            .catch(error => {
              return Promise.reject(error)
            })
        })
        .catch(error => {
          Vue.$log.fatal(error)

          return Promise.reject(error)
        })
    },
    post: (url, params) => {
      return valideMiddleToken()
        .then(token => {
          return new HttpClient()
            .post(`${BASE_URL}${url}`, params, {
              headers: { Authorization: 'Bearer ' + `${token}` }
            })
            .then(({ data }) => {
              return Promise.resolve(data)
            })
            .catch(error => {
              return Promise.reject(error)
            })
        })
        .catch(error => {
          Vue.$log.fatal(error)

          return Promise.reject(error.response)
        })
    },
    putSign: (url, signature) => {
      return valideMiddleToken()
        .then(token => {
          return new HttpClient()
            .put(`${BASE_URL}${url}`, signature, {
              headers: {
                Authorization: 'Bearer ' + `${token}`,
                'app-signed-at': timestampsSecondNow(),
                'app-image-format': 'data:image/png;base64'
              }
            })
            .then(({ data }) => {
              return Promise.resolve(data)
            })
            .catch(error => {
              Vue.$log.fatal(error)

              return Promise.reject(error)
            })
        })
        .catch(error => {
          return Promise.reject(error)
        })
    },
    put: (url, params) => {
      return valideMiddleToken()
        .then(token => {
          return new HttpClient()
            .put(`${BASE_URL}${url}`, params, {
              headers: { Authorization: 'Bearer ' + `${token}` }
            })
            .then(({ data }) => {
              return Promise.resolve(data)
            })
            .catch(error => {
              Vue.$log.fatal(error)

              return Promise.reject(error)
            })
        })
        .catch(error => {
          return Promise.reject(error)
        })
    },
    patch: (url, params) => {
      return valideMiddleToken()
        .then(token => {
          return new HttpClient()
            .patch(`${BASE_URL}${url}`, params, {
              headers: { Authorization: 'Bearer ' + `${token}` }
            })
            .then(({ data }) => {
              return Promise.resolve(data)
            })
            .catch(error => {
              return Promise.reject(error)
            })
        })
        .catch(error => {
          Vue.$log.fatal(error)
          return Promise.reject(error)
        })
    },
    delete: (url, params) => {
      return valideMiddleToken()
        .then(token => {
          return new HttpClient()
            .delete(`${BASE_URL}${url}`, {
              params: params,
              data: params,
              headers: { Authorization: 'Bearer ' + `${token}` }
            })
            .then(({ data }) => {
              return Promise.resolve(data)
            })
            .catch(error => {
              return Promise.reject(error)
            })
        })
        .catch(error => {
          Vue.$log.fatal(error)
          return Promise.reject(error)
        })
    }
  }
}

function valideMiddleToken() {
  const token = sessionStorage.getItem('tokenSession')
  const trainerID = sessionStorage.getItem('trainerIdSession')
  const uuid = sessionStorage.getItem('uuidSession')

  if (uuid === null || trainerID === null) {
    return Promise.reject()
  }
  return new HttpClient()
    .post(`${BASE_URL}nonce`, {
      deviceUId: uuid,
      trainerId: trainerID
    })
    .then(({ data }) => {
      const authToken = CryptoJS.SHA256(`${token}.${data.nonce}`)
      return `${CryptoJS.enc.Base64.stringify(authToken)}.${data.nonce}`
    })
    .catch(error => {
      return Promise.reject(error)
    })
}

/**
 * Token can only be used once
 * @param {String} trainerId - optional
 * @param {String} organizationToken - optional
 * @returns {Promise<never>|string} - base64_encode(hashedApiKey.trainerId.deviceUid.timestamp.nonce)
 */
export const disconnectToken = (trainerId, organizationToken) => {
  const appToken = organizationToken
    ? organizationToken
    : sessionStorage.getItem('tokenSession')
  const trainerID = trainerId
    ? trainerId
    : sessionStorage.getItem('trainerIdSession')
  const uuid = sessionStorage.getItem('uuidSession')
  const timestampSecond = timestampsSecondNow().toString()
  const nonce = Math.floor(Math.random() * 10000000).toString()

  if (uuid === null || trainerID === null) {
    return Promise.reject()
  }

  const hashedToken = CryptoJS.SHA256(
    appToken + '.' + timestampSecond + '.' + nonce
  )

  /**
   * @type {string} - hashedApiKey = base64_encode(sha256(appToken.timestamp.nonce)
   */
  const hashedApiKey = CryptoJS.enc.Base64.stringify(hashedToken)

  return btoa(
    `${hashedApiKey}.${trainerID}.${uuid}.${timestampSecond}.${nonce}`
  )
}
